<template>
  <span>
    <span v-for="(tag, index) in tags" :key="index">
      <router-link
        :to="`/tag/${tag.slug}`"
        v-html="tag.title" /><span v-if="index < tags.length - 1">, </span>
    </span>
  </span>
</template>
<script>
  export default {
    name: 'TagsList',
    props: [
      'tags'
    ]
  }
</script>


// WEBPACK FOOTER //
// src/components/TagsList.vue